import React, { useState } from "react";

export default function TextForm(props) {
  const HandleUpClick = () => {
    let newText = text.toUpperCase();
    setText(newText);
    props.showAlert("converted to Uppercase!", "success");
  };
  const HandleDownClick = () => {
    let newText = text.toLowerCase();
    setText(newText);
    props.showAlert("converted to Lowercase!", "success");
  };
  const HandleClearClick = () => {
    let newText = "";
    setText(newText);
    props.showAlert("Cleared!", "success");
  };

  const HandleOnChange = (event) => {
    console.log("HandleOnChange is clicked");
    setText(event.target.value);
  };

  const [text, setText] = useState("");

  return (
    <>
      <div
        className="container"
        style={{
          color: props.mode === "dark" ? "white" : "#042743",
        }}
      >
        <h1>{props.heading}</h1>
        <div className="mb-3">
          <label htmlFor="myBox" className="form-label"></label>
          <textarea
            placeholder="enter your text here"
            style={{
              backgroundColor: props.mode === "dark" ? "black" : "white",
              color: props.mode === "dark" ? "white" : "#042743",
            }}
            className="form-control"
            onChange={HandleOnChange}
            value={text}
            id="myBox"
            rows="8"
          ></textarea>
        </div>
        <button className="btn btn-primary" onClick={HandleUpClick}>
          Convert to Uppercase
        </button>
        <button className="btn btn-primary mx-3" onClick={HandleDownClick}>
          Convert to Lowercase
        </button>
        <button className="btn btn-primary " onClick={HandleClearClick}>
          Clear Text
        </button>
      </div>

      <div
        className="card"
        style={{
          width: 18 + "rem",
          marginTop: 20 + "px",
          backgroundColor: props.mode === "dark" ? "black" : "white",

          color: props.mode === "dark" ? "white" : "#042743",
        }}
      >
        <div className="card-body">
          <h5 className="card-title">Text Data</h5>

          <p>
            {text.split(" ").length} words and {text.length} characters.
          </p>
          <p>{Math.round(0.008 * text.split(" ").length)} minutes read.</p>
        </div>
      </div>
      <div
        className="container my-3"
        style={{ color: props.mode === "dark" ? "white" : "#042743" }}
      >
        <h3>Preview</h3>
        <p>
          {text.length > 0 ? text : "enter some text above to preview here."}
        </p>
      </div>
    </>
  );
}
